import React from 'react';
import PropTypes from 'prop-types';
import './ArchivalLoader.scss';
import counterpart from 'counterpart';

const ArchivalLoader = (props) => {
  return (
    <div className="archival-wrapper">
      <svg
        version="1.1"
        id="CL"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 368 100"
        enableBackground="new 0 0 100 100"
        xmlSpace="preserve"
        style={{ width: props.width }}
      >
        <text x="50%" y="20%" text-anchor="middle" class="first-text" fill={props.fill}>{counterpart('globalTranslate.archiveLoader.waitLoading')}</text>
        <text x="50%" y="60%" dominant-baseLine="middle" text-anchor="middle" class="secondary-text">
        {counterpart('globalTranslate.archiveLoader.waitText')}
        </text>
        <text x="50%" y="80%" dominant-baseLine="middle" text-anchor="middle" class="secondary-text">
        {counterpart('globalTranslate.archiveLoader.waitMessage')}
        </text>
      </svg>
    </div>
  );
};

export default ArchivalLoader;
